module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_5000_10000.33a4a3fa.png";